import { rem } from 'polished'
import styled from 'styled-components'
import LoyaltyInfiniteLogo from './LoyaltyInfiniteLogo'
import LoyaltyInfiniteSwash from './LoyaltyInfiniteSwash'

/**
 * The Société Infinite brand logo — the rose-gold "le" swash emblem followed by the INFINITE
 * wordmark. Composed from the shared `LoyaltyInfiniteSwash` + `LoyaltyInfiniteLogo` so the emblem
 * and letterforms stay consistent with the rest of the app. Size via the `height` prop (px).
 */
const Wrapper = styled.span`
  display: inline-flex;
  align-items: center;
  line-height: 0;
`

const Emblem = styled(LoyaltyInfiniteSwash)`
  height: 100%;
  width: auto;
`

const Wordmark = styled(LoyaltyInfiniteLogo)`
  height: 55%;
  width: auto;
`

interface Props {
  className?: string
  /** Brand-logo height in px (the emblem and wordmark scale to it). */
  height?: number
  /**
   * `gradient` (default) renders the rose-gold gradient; `dark` renders it flat in solid black.
   * @default gradient
   */
  variant?: 'gradient' | 'dark'
}

function LoyaltyInfiniteBrandLogo({ className, height = 22, variant = 'gradient' }: Props) {
  return <Wrapper className={className} style={{ height: rem(height), gap: rem(height * 0.3) }}>
    <Emblem variant={variant} />
    <Wordmark variant={variant} />
  </Wrapper>
}

export default LoyaltyInfiniteBrandLogo
